/**
 * @enum RewardTypes
 * @description Reward types
 */
enum RewardTypes {
    NONE = "NONE",
    PARTICIPATION = "PARTICIPATION",
    TROPHY = "TROPHY",
    SPECIAL = "SPECIAL",
};

export default RewardTypes;